<template>
 <v-dialog v-model="dialogCreatenote" max-width="500px" persistent max-height="500px" style="overflow: hidden !important;">
  <v-card style="border-radius:20px;">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai"><v-icon color="white">fas fa-sticky-note</v-icon>&nbsp;&nbsp;{{$t('Dialog.note.headerCreate')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-text>
      <v-layout align-center justify-center row wrap>
        <textarea v-model="edittext" style="width: 100%; height: 200px; background: #1a222b12;
        padding: 20px;"> </textarea>
      </v-layout>
      <v-layout align-center justify-center row wrap>
        <v-flex xs6 sm6 md6>
          <v-layout align-center justify-end row wrap style="padding-right: 10px;">
            <v-btn dark @click="closeDialog" class="btncancel text-transform">
              {{$t('AnswerQuestion.cancel')}}
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex xs6 sm6 md6>
          <v-layout align-center justify-start row wrap>
            <v-btn  dark @click="save" v-if="/\S/.test(edittext)" class="btnallow text-transform" :loading="loading">
              {{$t('AnswerQuestion.ok')}}
            </v-btn>
            <v-btn v-else disabled class="btnallow text-transform">
              {{$t('AnswerQuestion.ok')}}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
// import { Momenttime } from '@/services'
import { Decode } from '@/services'

export default {
  props: {dialogCreatenote: false, tokenroom: ''},
  data: () => ({
    tokenuser: '',
    edittext: '',
    loading: false,
  }),
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = decoded['tokenuser']
  },
  methods: {
    closeDialog () {
      this.edittext = ''
      this.$emit('closeCreatenote', false)
    },
    save () {
      this.loading = true
      if (/\S/.test(this.edittext)) {
        // console.log('not empty')
        this.axios.post(process.env.APImanage + '/createnote', {tokenuser: this.tokenuser, text: this.edittext, tokenroom: this.tokenroom}).then((response) => {
          if (response.data.status === 'success') {
            this.loading = false
            // console.log(response.data)
            this.$swal('', this.$t('Alert.Success.createNote'), 'success')
            this.$emit('CreateNote', 'success', response.data.create_date, response.data.note_id, response.data.tokenroom, response.data.update_date, this.edittext)
            this.closeDialog()
          } else {
            this.loading = false
            this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
          }
        }).catch(err => {
          this.loading = false
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    }
  },
  watch: {
  }
}
</script>
<style type="text/css" scoped>
.text-transform {
  text-transform: none;
}
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #2562af !important;
  color: white !important;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #e0e0e0 !important;
  color: black !important;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.application .theme--light.input-group input, .application .theme--light.input-group textarea, .theme--light .input-group input, .theme--light .input-group textarea {
    /* color: rgba(0,0,0,.87); */
    color: #53ceff !important;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.user-photonote{
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display:inline-flex;
}
input[type=textadd] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 12px 12px 12px 12px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/CreateNoteDialogMobile.vue